module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "general"
  }, [(_vm.settings) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "box coverage"
  }, [_c('div', {
    staticClass: "box__title"
  }, [_vm._v("\n                    Dækningsgrad (DG)\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "options"
  }, [_c('div', {
    staticClass: "option"
  }, [_c('div', {
    staticClass: "fake-input"
  }, [_c('b', [_vm._v("0 - " + _vm._s(_vm.settings.coverage_percent.medium.value - 1) + " %")])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _c('div', {
    staticClass: "option"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.settings.coverage_percent.medium.value),
      expression: "settings.coverage_percent.medium.value"
    }],
    attrs: {
      "type": "number",
      "name": "coverage_percent_medium",
      "min": "0",
      "max": "80",
      "step": "1",
      "pattern": "\\d*",
      "maxlength": "2"
    },
    domProps: {
      "value": (_vm.settings.coverage_percent.medium.value)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.settings.coverage_percent.medium, "value", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('b', [_vm._v(" - " + _vm._s(_vm.settings.coverage_percent.high.value - 1) + " %")]), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3)]), _vm._v(" "), _c('div', {
    staticClass: "option"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.settings.coverage_percent.high.value),
      expression: "settings.coverage_percent.high.value"
    }],
    attrs: {
      "type": "number",
      "name": "coverage_percent_high",
      "min": "0",
      "max": "80",
      "step": "1",
      "pattern": "\\d*",
      "maxlength": "2"
    },
    domProps: {
      "value": (_vm.settings.coverage_percent.high.value)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.settings.coverage_percent.high, "value", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('b', [_vm._v(" - 100 %")]), _vm._v(" "), _vm._m(4), _vm._v(" "), _vm._m(5)])])])])]) : _vm._e(), _vm._v(" "), (_vm.settings) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "box coverage"
  }, [_c('div', {
    staticClass: "box__title"
  }, [_vm._v("\n                    Dækningsbidrag (DB) pr. time\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "options"
  }, [_c('div', {
    staticClass: "option"
  }, [_c('div', {
    staticClass: "fake-input"
  }, [_c('b', [_vm._v("0 - " + _vm._s(_vm.settings.coverage_per_hour.medium.value - 1) + " kr.")])]), _vm._v(" "), _vm._m(6), _vm._v(" "), _vm._m(7)]), _vm._v(" "), _c('div', {
    staticClass: "option"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.settings.coverage_per_hour.medium.value),
      expression: "settings.coverage_per_hour.medium.value"
    }],
    attrs: {
      "type": "number",
      "name": "coverage_per_hour_medium",
      "min": "0",
      "max": "8000",
      "step": "1",
      "pattern": "\\d*",
      "maxlength": "4"
    },
    domProps: {
      "value": (_vm.settings.coverage_per_hour.medium.value)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.settings.coverage_per_hour.medium, "value", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('b', [_vm._v(" - " + _vm._s(_vm.settings.coverage_per_hour.high.value - 1) + " kr.")]), _vm._v(" "), _vm._m(8), _vm._v(" "), _vm._m(9)]), _vm._v(" "), _c('div', {
    staticClass: "option"
  }, [_vm._v("\n                        + \n                        "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.settings.coverage_per_hour.high.value),
      expression: "settings.coverage_per_hour.high.value"
    }],
    attrs: {
      "type": "number",
      "name": "coverage_per_hour_high",
      "min": "0",
      "max": "8000",
      "step": "1",
      "pattern": "\\d*",
      "maxlength": "4"
    },
    domProps: {
      "value": (_vm.settings.coverage_per_hour.high.value)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.settings.coverage_per_hour.high, "value", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('b', [_vm._v(" kr.")]), _vm._v(" "), _vm._m(10), _vm._v(" "), _vm._m(11)])])])])]) : _vm._e(), _vm._v(" "), (_vm.settings) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "box coverage"
  }, [_c('div', {
    staticClass: "box__title"
  }, [_vm._v("\n                    Registreret tid\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "options"
  }, [_c('div', {
    staticClass: "option"
  }, [_c('div', {
    staticClass: "fake-input"
  }, [_c('b', [_vm._v("0 - " + _vm._s(_vm.settings.timelogging.medium.value - 1) + " %")])]), _vm._v(" "), _vm._m(12), _vm._v(" "), _vm._m(13)]), _vm._v(" "), _c('div', {
    staticClass: "option"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.settings.timelogging.medium.value),
      expression: "settings.timelogging.medium.value"
    }],
    attrs: {
      "type": "number",
      "name": "coverage_percent_medium",
      "min": "0",
      "max": "80",
      "step": "1",
      "pattern": "\\d*",
      "maxlength": "2"
    },
    domProps: {
      "value": (_vm.settings.timelogging.medium.value)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.settings.timelogging.medium, "value", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('b', [_vm._v(" - " + _vm._s(_vm.settings.timelogging.high.value - 1) + " %")]), _vm._v(" "), _vm._m(14), _vm._v(" "), _vm._m(15)]), _vm._v(" "), _c('div', {
    staticClass: "option"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.settings.timelogging.high.value),
      expression: "settings.timelogging.high.value"
    }],
    attrs: {
      "type": "number",
      "name": "coverage_percent_high",
      "min": "0",
      "max": "80",
      "step": "1",
      "pattern": "\\d*",
      "maxlength": "2"
    },
    domProps: {
      "value": (_vm.settings.timelogging.high.value)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.settings.timelogging.high, "value", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('b', [_vm._v(" - 100 %")]), _vm._v(" "), _vm._m(16), _vm._v(" "), _vm._m(17)])])])])]) : _vm._e(), _vm._v(" "), (_vm.settings) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "box coverage"
  }, [_c('div', {
    staticClass: "box__title"
  }, [_vm._v("\n                    Beregning af medarbejdernes indtjening\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-6"
  }, [_c('div', {
    staticClass: "inside"
  }, [_c('div', {
    staticStyle: {
      "display": "flex"
    }
  }, [_c('span', {
    staticStyle: {
      "display": "block",
      "width": "1.4em"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.employeeCalc),
      expression: "employeeCalc"
    }],
    attrs: {
      "type": "radio",
      "name": "employee-calculation",
      "value": "responsible"
    },
    domProps: {
      "checked": _vm._q(_vm.employeeCalc, "responsible")
    },
    on: {
      "change": [function($event) {
        _vm.employeeCalc = "responsible"
      }, function($event) {
        return _vm.selectEmployeeCalc('responsible')
      }]
    }
  })]), _vm._v(" "), _c('span', {
    staticStyle: {
      "margin-left": "10px"
    }
  }, [_vm._v("Indtjening tilfalder den medarbejder, der har arbejdet mest på opgaven")])]), _vm._v(" "), _c('div', {
    staticClass: "options"
  }, [_c('div', {
    staticClass: "option fw"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.settings.main_employee_percent),
      expression: "settings.main_employee_percent"
    }],
    attrs: {
      "type": "number",
      "name": "main_employee_percent",
      "min": "50",
      "max": "99",
      "step": "1",
      "pattern": "\\d*",
      "maxlength": "2"
    },
    domProps: {
      "value": (_vm.settings.main_employee_percent)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.settings, "main_employee_percent", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('b', [_vm._v("%")])])]), _vm._v(" "), _c('i', [_vm._v("Bemærk, at en ændring i dette felt først træder ikraft næste dag.")]), _vm._v(" "), _c('div', {
    staticClass: "small"
  }, [_vm._v("\n                                Her fastsættes, hvor stor en andel af det samlede antal timer på en opgave, som skal være udført af 1 svend, før indtjeningen tildeles 1 svend. Andelen kan ikke komme under 50%\n                            ")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6"
  }, [_c('div', {
    staticClass: "inside"
  }, [_c('div', {
    staticStyle: {
      "display": "flex"
    }
  }, [_c('span', {
    staticStyle: {
      "display": "block",
      "width": "1.4em"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.employeeCalc),
      expression: "employeeCalc"
    }],
    attrs: {
      "type": "radio",
      "name": "employee-calculation",
      "value": "calculation"
    },
    domProps: {
      "checked": _vm._q(_vm.employeeCalc, "calculation")
    },
    on: {
      "change": [function($event) {
        _vm.employeeCalc = "calculation"
      }, function($event) {
        return _vm.selectEmployeeCalc('calculation')
      }]
    }
  })]), _vm._v(" "), _c('span', {
    staticStyle: {
      "margin-left": "10px"
    }
  }, [_vm._v("Indtjening fordeles ud fra antal timer lagt i en opgave")])]), _vm._v(" "), _c('div', {
    staticClass: "small"
  }, [_vm._v("\n                                De enkelte opgavers omsætning/omkostning/indtjening fordeles forholdsmæssigt på ALLE medarbejdere, som har arbejdet på opgaven. Hvis f.eks. “Mads” har udført 30% af timerne, tildeles han 30% af indtjeningen.\n                            ")])])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "15px",
      "font-size": "14px"
    }
  }, [_vm._v("\n                    Bemærk, at ændringerne for begge ovenstående beregninger først træder ikraft næste dag.\n                ")])])])]) : _vm._e(), _vm._v(" "), (_vm.settings) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-6"
  }, [_c('div', {
    staticClass: "box coverage"
  }, [_c('div', {
    staticClass: "box__title"
  }, [_vm._v("\n                    Fakturaer med overskredet betaling\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "options"
  }, [_c('div', {
    staticClass: "option fw"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.settings.overdue_days),
      expression: "settings.overdue_days"
    }],
    attrs: {
      "type": "number",
      "name": "overdue_days",
      "min": "0",
      "max": "99",
      "step": "1",
      "pattern": "\\d*",
      "maxlength": "2"
    },
    domProps: {
      "value": (_vm.settings.overdue_days)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.settings, "overdue_days", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('b', [_vm._v("dage")]), _vm._v(" "), _c('div', {
    staticClass: "small"
  }, [_vm._v("\n                            Her fastsættes, hvor mange dage betalingsfristen må være overskredet, før den skal vises på oversigten.\n                        ")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6"
  }, [_c('div', {
    staticClass: "box coverage"
  }, [_c('div', {
    staticClass: "box__title"
  }, [_vm._v("\n                    Opgaver uden bevægelse\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "options"
  }, [_c('div', {
    staticClass: "option fw"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.settings.snoozed_days),
      expression: "settings.snoozed_days"
    }],
    attrs: {
      "type": "number",
      "name": "snoozed_days",
      "min": "0",
      "max": "99",
      "step": "1",
      "pattern": "\\d*",
      "maxlength": "2"
    },
    domProps: {
      "value": (_vm.settings.snoozed_days)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.settings, "snoozed_days", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('b', [_vm._v("dage")]), _vm._v(" "), _c('div', {
    staticClass: "small"
  }, [_vm._v("\n                            Her fastsættes, hvor mange dage der må gå uden registrering af timer eller materialer på en opgave, før den skal vises på oversigten.\n                        ")])])])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12",
    attrs: {
      "align": "right"
    }
  }, [_c('div', {
    staticClass: "pretty-button inverse",
    on: {
      "click": function($event) {
        return _vm.doReset()
      }
    }
  }, [_c('i', {
    staticClass: "far fa-history fa-fw"
  }), _vm._v("\n                Gendan standardindstillinger\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "pretty-button",
    on: {
      "click": function($event) {
        return _vm.doSave()
      }
    }
  }, [_c('i', {
    staticClass: "far fa-save fa-fw"
  }), _vm._v("\n                Gem\n            ")])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "name"
  }, [_c('div', {
    staticClass: "coverage-indicator bad"
  }), _vm._v("\n                            Utilfredsstillende\n                        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "small"
  }, [_vm._v("\n                            DG vil være "), _c('span', {
    staticClass: "color bad"
  }, [_vm._v("rød")]), _vm._v(", hvis den er i dette interval\n                        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "name"
  }, [_c('div', {
    staticClass: "coverage-indicator avg"
  }), _vm._v("\n                            Middel\n                        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "small"
  }, [_vm._v("\n                            DG vil være "), _c('span', {
    staticClass: "color avg"
  }, [_vm._v("gul")]), _vm._v(", hvis den er i dette interval\n                        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "name"
  }, [_c('div', {
    staticClass: "coverage-indicator good"
  }), _vm._v("\n                            Tilfredsstillende\n                        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "small"
  }, [_vm._v("\n                            DG vil være "), _c('span', {
    staticClass: "color good"
  }, [_vm._v("grøn")]), _vm._v(", hvis den er i dette interval\n                        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "name"
  }, [_c('div', {
    staticClass: "coverage-indicator bad"
  }), _vm._v("\n                            Utilfredsstillende\n                        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "small"
  }, [_vm._v("\n                            DB pr. time vil være "), _c('span', {
    staticClass: "color bad"
  }, [_vm._v("rød")]), _vm._v(", hvis den er i dette interval\n                        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "name"
  }, [_c('div', {
    staticClass: "coverage-indicator avg"
  }), _vm._v("\n                            Middel\n                        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "small"
  }, [_vm._v("\n                            DB pr. time vil være "), _c('span', {
    staticClass: "color avg"
  }, [_vm._v("gul")]), _vm._v(", hvis den er i dette interval\n                        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "name"
  }, [_c('div', {
    staticClass: "coverage-indicator good"
  }), _vm._v("\n                            Tilfredsstillende\n                        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "small"
  }, [_vm._v("\n                            DB pr. time vil være "), _c('span', {
    staticClass: "color good"
  }, [_vm._v("grøn")]), _vm._v(", hvis den er over dette tal\n                        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "name"
  }, [_c('div', {
    staticClass: "coverage-indicator bad"
  }), _vm._v("\n                            Utilfredsstillende\n                        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "small"
  }, [_vm._v("\n                            Registreret tid vil være "), _c('span', {
    staticClass: "color bad"
  }, [_vm._v("rød")]), _vm._v(", hvis den er i dette interval\n                        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "name"
  }, [_c('div', {
    staticClass: "coverage-indicator avg"
  }), _vm._v("\n                            Middel\n                        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "small"
  }, [_vm._v("\n                            Registreret tid vil være "), _c('span', {
    staticClass: "color avg"
  }, [_vm._v("gul")]), _vm._v(", hvis den er i dette interval\n                        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "name"
  }, [_c('div', {
    staticClass: "coverage-indicator good"
  }), _vm._v("\n                            Tilfredsstillende\n                        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "small"
  }, [_vm._v("\n                            Registreret tid vil være "), _c('span', {
    staticClass: "color good"
  }, [_vm._v("grøn")]), _vm._v(", hvis den er i dette interval\n                        ")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3d3aa354"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/settings/components/general.vue
// module id = 845
// module chunks = 0